(function (_) {
    'use strict';

    _['MONDAY'] ='Segunda-feira';
    _['TUESDAY'] ='Terça-feira';
    _['WEDNESDAY'] ='Quarta-feira';
    _['THURSDAY'] ='Quinta-feira';
    _['FRIDAY'] ='Sexta-feira';
    _['SATURDAY'] ='Sábado';
    _['SUNDAY'] ='Domingo';
    _['MONDAY_SHORT'] ='S';
    _['TUESDAY_SHORT'] ='T';
    _['WEDNESDAY_SHORT'] ='Q';
    _['THURSDAY_SHORT'] ='Q';
    _['FRIDAY_SHORT'] ='S';
    _['SATURDAY_SHORT'] ='S';
    _['SUNDAY_SHORT'] ='D';
    _['CHOOSE_CALENDAR'] ='Escolhe um calendário';
    _['ALL_CALENDARS'] ='Todos os calendários';

    _['JANUARY'] ='Janeiro';
    _['FEBRUARY'] ='Fevereiro';
    _['MARCH'] ='Março';
    _['APRIL'] ='Abril';
    _['MAY'] ='Maio';
    _['JUNE'] ='Junho';
    _['JULY'] ='Julho';
    _['AUGUST'] ='Agosto';
    _['SEPTEMBER'] ='Setembro';
    _['OCTOBER'] ='Outubro';
    _['NOVEMBER'] ='Novembro';
    _['DECEMBER'] ='Dezembro';

    _['CALENDAR.KEY'] ='Reservas';
    _['CALENDAR.MY_BOOKINGS'] ='As minhas reservas';
    _['MAKE_RESERVATION'] ='Faz a tua reserva ';

    _['CALENDAR.DATE'] ='Data';
    _['CALENDAR.DATE_PLACEHOLDER'] ='Data da reserva';
    _['CALENDAR.CANCEL_RESERVATION'] ='Cancelar reserva';
    _['CALENDAR.INTERVAL'] ='Hora';
    _['CALENDAR.INTERVAL_PLACEHOLDER'] ='Seleciona um horário';
    _['CALENDAR.MAX_ATTENDANTS'] ='Número de pessoas';
    _['CALENDAR.COMMENTS'] ='Comentários';
    _['CALENDAR.COMMENTS_PLACEHOLDER'] ='Deixa um comentário...';
    _['CALENDAR.AVAILABLE'] ='disponível/veis';
    _['CALENDAR.EVENT_NOT_AVAILABLE'] ='Não é possível fazer uma reserva. Pode ser que alguém tenha feito uma reserva antes de teres confirmado a tua.';
    _['CALENDAR.INVALID_EVENT'] ='A hora selecionada não é válida.';
    _['CALENDAR.EVENT_PAST'] ='Não é possível a hora que escolheste, não a podes selecionar.';

    _['CALENDAR.BOOKING_SUCCESS_TITLE'] ='A tua reserva foi feita corretamente';
    _['CALENDAR.BOOKING_SUCCESS_MSG'] ='Acabas de fazer uma reserva e precisas de  receber a confirmação da mesma. Depois de a receberes, a reserva fica válida e podes usufruir dela.';
        
    _['CALENDAR.NO-BOOKINGS'] ='Não há nenhuma reserva.';
    _['CALENDAR.STATUS'] ='Estado';
    _['CALENDAR.PENDING'] ='Pendente';
    _['CALENDAR.ACCEPTED'] ='Aceita';
    _['CALENDAR.USER_DENIED'] ='Cancelada';
    _['CALENDAR.CREATOR_DENIED'] ='Negada';
    _['CALENDAR.CALENDAR'] ='Calendário';
    _['CALENDAR.ATTENDANTS'] ='Participantes';

    _['BOOKINGS.MENU'] ='As minhas reservas';
}(translations['pt']));



// WEBPACK FOOTER //
// ./src/app/modules/booking/lang/booking-lang_pt.js